

export const OpcionesProductos = ({ history, itemSelected, itemTitulo, lstProductos, opcionPrincipal }) => {

    return (
        <div className="gridOptions-third">
            <div className="gridOptions-third-links scrollSlider">
                {
                    lstProductos
                        .slice(0, 10)
                        .map(
                            (p, i) => {
                                return (
                                    <div
                                        className="gridOptions-third-links-item"
                                        key={i + p.codigoSku}
                                    >
                                        {
                                            (p.promocion.filter(promo => promo.tipoDescuento == 1).length > 0 ||
                                                p.promocionRedime.filter(promoR => promoR.tipoDescuento == 5).length > 0)
                                            &&
                                            <i className="fas fa-fire"><div></div></i>
                                        }
                                        <a
                                            style={
                                                {
                                                    cursor: "pointer",
                                                    hover:
                                                        "text-decoration:underline",

                                                }
                                            }
                                            onClick={
                                                () => {
                                                    var ruta = history.location.pathname.split("/");
                                                    if (ruta[1] === "detalleProducto") {
                                                        var res =
                                                            p.nombre
                                                                .normalize("NFD")
                                                                .replace(/[\u0300-\u036f]/g, "")
                                                                .toLowerCase()
                                                                .replace(/ /g, "-") +
                                                            "-" +
                                                            p.codigoSku;
                                                        history.push('/detalleProducto/' + res)
                                                        window.location.reload();
                                                        window.scrollTo(0, 0);
                                                    }
                                                    else {
                                                        var res =
                                                            p.nombre
                                                                .normalize("NFD")
                                                                .replace(/[\u0300-\u036f]/g, "")
                                                                .toLowerCase()
                                                                .replace(/ /g, "-") +
                                                            "-" +
                                                            p.codigoSku;
                                                        history.push('/detalleProducto/' + res)
                                                    }
                                                }
                                            }
                                        >
                                            {
                                                p.nombre
                                            }
                                        </a>
                                    </div>
                                )
                            }
                        )
                }
            </div>

            <div className="gridOptions-third-catalogue">
                <div className="gridOptions-third-catalogue-last no-seleccionable">
                    <a
                        //Catalogo/Marcas/23/Colombiana/1
                        onClick={
                            () => {
                                var categoria = opcionPrincipal == 'categoria_id' ? 'Categoria' : opcionPrincipal == 'marca_id' ? 'Marcas' : "";
                                history.push({
                                    pathname: '/Catalogo/' + categoria + '/' + itemSelected + '/' + itemTitulo.trim() + "/1",
                                })
                            }
                        }
                    >Ver todos los productos</a>
                </div>
            </div>

        </div>
    )
}
